module.exports = __webpack_public_path__ + "static/media/nft-GradientAbstractShapes.84b99dfd.png";